import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse, ListResponse } from '../../utils/listResponse';
import { Run, RunStatus, StatusCode } from '../models/run';
import { runSchema } from '../models/run.schema';
import { LogLevel } from '../models/runLog';
import { runsQuerySchema } from './runs.schema';

export type RunsQuery = PaginationQuery &
  Partial<{
    timestampAfter: string;
    timestampBefore: string;
    startAfter: string;
    startBefore: string;
    endAfter: string;
    endBefore: string;
    search: string;
    hook: Array<number>;
    uuid: Array<string>;
    requestId: string;
    /** @deprecated logLevel will be removed along with Logs screen removal */
    logLevel: LogLevel;
    statusCode: Array<StatusCode>;
    queue: Array<string>;
    annotation: Array<number>;
    email: Array<string>;
    status: Array<RunStatus>;
  }>;

/**
 * @noSchema
 */
export type Runs = ListResponse<Run>;

export const runs = (query: RunsQuery = {}) => {
  return {
    endpoint: `/hooks/runs`,
    method: 'GET',
    responseSchema: listResponse(runSchema),
    query: { ...query, includeTotal: true },
    querySchema: runsQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
